<template>
  <div class="home"><!-- :style="{width:width + 'px',height:height + 'px',marginLeft:left + 'px'}" -->
    <img src="../images/home.jpg" style="margin-bottom: -15px"> 
    <div class="one" @click="cameraPic('qc_302689_654649_2')"></div>
    <div class="two" @click="cameraPic('qc_302689_246119_1')"></div>
    <div class="three" @click="cameraPic('qc_302689_599816_3')"></div>
    <div class="four" @click="cameraPic('qc_302689_416838_4')"></div>
    <div class="biyezheng" @click="openSubmit"></div>
    <div class="loading" v-if="isLoading">
      <div class="box">
        <img src="../images/timg.gif" style="width:5rem;height: 3.6rem;">
        <p>{{loadingText}}</p>
      </div>
    </div>
    <div class="submit_box" v-if="isShowSubmit">
      <div class="box">
          <div class="close" @click="closeSubmit"><i class="el-icon-close"></i></div>
          <div class="input-box">
            <div class="line-box">
              <p>姓名</p>
              <el-input v-model="name" clearable placeholder="请输入姓名" style="width:220px"></el-input>
            </div>
            <div class="line-box">
              <p>培训班</p>
              <el-select placeholder="请选择培训班" v-model="peixb" style="width:220px" @change="changeP">
                <el-option label="安宁市2020年入党积极分子培训班" value="安宁市2020年入党积极分子培训班"></el-option>
                <el-option label="安宁市2020年党员发展对象培训班（第二期）" value="安宁市2020年党员发展对象培训班（第二期）"></el-option>
                <el-option label="安宁市2020年”万名党员进党校“培训班" value="安宁市2020年”万名党员进党校“培训班"></el-option>
                <el-option label="安宁市2020年党员干部教育师资暨新时代文明实践理论宣讲员能力素质提升培训班" value="安宁市2020年党员干部教育师资暨新时代文明实践理论宣讲员能力素质提升培训班"></el-option>
                <el-option label="其他班次" value="其他班次"></el-option>
              </el-select>
            </div>
            <div class="line-box" v-show="isShow" ><el-input v-model="qita" clearable placeholder="请输入培训班"></el-input></div>
            <div class="line-box">
              <p>课时</p>
              <el-input v-model="keshi" clearable placeholder="请输入课时" style="width:220px"></el-input>
            </div>
            <div class="line-box">
              <p>起始日期</p>
              <el-date-picker v-model="startDate" format="yyyy年MM月dd日" :picker-options="pickerOptionsStart" type="date" placeholder="请输入起始日期"></el-date-picker>
            </div>
            <div class="line-box">
              <p>结束日期</p>
              <el-date-picker v-model="endDate" type="date" format="yyyy年MM月dd日" :picker-options="pickerOptionsEnd" placeholder="请输入结束日期"></el-date-picker>
            </div>
          </div>
          <div class="btn" @click="submitData">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
  // import utils from '../../assets/utils.js'
export default {
  name: 'home',
  data () {
    return {
      isLoading:false,
      isShowSubmit:false,
      loadingText:'',
      name:'',
      keshi:'',
      startDate:'',
      endDate:'',
      peixb:'',
      qita:'',
      isShow:false,
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.endDate) {
            return time.getTime() > Date.now() || time.getTime() > this.endDate;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.startDate) {
            return time.getTime() < this.startDate || time.getTime() > Date.now();
          }
          return time.getTime() < this.startDate || time.getTime() > Date.now();
        }
      }
    }
  },
  mounted(){
    // var height = document.documentElement.clientHeight;
    // var screenWidth = document.documentElement.clientWidth;
    // this.width = (height * 16/9).toFixed(2)*1;
    // this.height = height;
    // this.left = ((screenWidth - this.width)/2).toFixed(2) * 1;
    // this.isLoading = true;
    // this.loadingText = '图片生成中'
    // var data = {
    //           ProjectId:'302689',
    //           ModelId:'qc_302689_599816_3',//素材id
    //           Image:'',
    //           RspImgType:'url',
    //         }
    //       this.$post("image/merge", data).then(res => {
    //         if(res.code == 200){
    //           this.isLoading = false;
    //           this.$router.push({ name: 'download',query: {imgUrl:res.data.data.image}})
    //         }else{
    //           this.isLoading = false;
    //           window.alert(res.msg);
    //         }
    //       });
  },

  methods:{
    changeP(e){
      if(e == '其他班次'){
        this.isShow = true;
      }else{
        this.isShow = false
      }
    },
    formateDate(datetime) {
        if (datetime != '') {
          function addDateZero(num) {
            return (num < 10 ? "0" + num : num);
          }
          let d = new Date(datetime)
          let formatdatetime = d.getFullYear() + '年' + addDateZero(d.getMonth() + 1) + '月' + addDateZero(d.getDate()) + '日';
          return formatdatetime;
        }
        return ''
      },


    //提交信息
    submitData:function(){
      var date = new Date();
      var year = date.getFullYear();
      var month = (date.getMonth() + 1);
      month = month <= 9 ? '0' + month : month;
      var day = date.getDate();
      day = day <= 9 ? '0' + day : day;
      var todayDate = year +'年'+month +'月'+ day + '日';
      var data = {
        name:this.name,
        content:`同志，于${this.formateDate(this.startDate != '' ? this.startDate : '') || ''}至${this.formateDate(this.endDate != '' && this.endDate!=null ? this.endDate.getTime()+(24*3600-1)*1000 : '') || ''}参加${this.qita!='' ? this.qita:this.peixb}，已完成`,
        courses:this.keshi,
        suffixContent:'个培训学时，准予结业。',
        todayDate:todayDate
      }
      this.isLoading = true;
      this.loadingText = '数据提交中'
      this.$post("image/fill-text", data).then(res => {
            if(res.code == 200){
              this.isLoading = false;
              this.isShowSubmit = false;
              this.$router.push({ name: 'biyezheng',query: {imgUrl:res.data.url}})
            }else{
              this.isLoading = false;
              window.alert(res.msg);
            }
          });
    },
    //关闭提交信息盒子
    closeSubmit:function(){
      this.isShowSubmit = false;
      this.name = '';
      this.startDate = '';
      this.endDate = ''
    },
    //打开提交盒子
    openSubmit:function(){
      this.isShowSubmit = true
    },
    // 拍照
    cameraPic:function(string){
      var _self = this;
      navigator.camera.getPicture(
        function success(imageUrl){
          _self.faceImage(imageUrl,string)
          
      },
      function fail(message) {
        // window.alert('操作失败，原因：' + message,null,'警告')
      },
      {
        qulity:75,
        mediaType: navigator.camera.MediaType.PICTURE,
        sourceType: navigator.camera.PictureSourceType.CAMERA,//拍照
        // destinationType:navigator.camera.DestinationType.FILE_URI //拍一张图片，返回图片文件的位置
        destinationType:navigator.camera.DestinationType.DATA_URL //拍一张照片，返回它的64编码的图像
      })
    },


    //上传
    faceImage:function(url,picId){
      this.isLoading = true;
      this.loadingText = '图片生成中'
      var data = {
              ProjectId:'302689',
              ModelId:picId,//素材id
              Image:url,
              RspImgType:'url',
            }
          this.$post("image/merge", data).then(res => {
            if(res.code == 200){
              this.isLoading = false;
              this.$router.push({ name: 'download',query: {imgUrl:res.data.data.image}})
            }else{
              this.isLoading = false;
              window.alert(res.msg);
            }
          });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home{
    width:100%;
    height: 100vh;
    position: relative;
  }
  .home img{
    /*position: absolute;*/
    width:100%;
    height: 100%;
  }
  .one{
    position: absolute;
    bottom: 0;
    left: 2%;
    width: 3rem;
    /*background: rgba(0,0,0,.3);*/
    height: 9.8rem;
  }
  .two{
    position: absolute;
    bottom: 0;
    left: 18%;
    /*background: rgba(0,0,0,.3);*/
    height: 8.8rem;
    width: 3.4rem;
  }
  .three{
    position: absolute;
    right: 21%;
    /*background: rgba(0,0,0,.3);*/
    bottom: 0;
    height: 8.8rem;
    width: 2.7rem
  }
  .four{
    position: absolute;
    /*background: rgba(0,0,0,.3);*/
    right: 5.2%;
    bottom: 0;
    height: 9.6rem;
    width: 2.8rem;
  }
  .biyezheng{
    width: 5.6rem;
    height: 4rem;
    /*background: rgba(0,0,0,.3);*/
    position: absolute;
    left: 35.9%;
    top: 21.7%;
  }
  .loading{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    top: 0;
    left: 0;
    z-index: 11
  }
  .loading .box{
    width: 6rem;
    height: 4.4rem;
    background: #fbfbf9;
    text-align: center;
    border-radius: 5px;
    margin-left: calc(50% - 3rem);
    position: absolute;
    top: 50%;
    margin-top: -2.2rem
  }
  .loading .box p{
    font-size: .4rem;
    margin-top: -.8rem;
  }
  .submit_box{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    top: 0;
    left: 0;
    z-index: 10
  }
  .submit_box .box{
    width:6.6rem;
    height: 8.4rem;
    background: #fff;
    border-radius: 5px;
    position: relative;
    margin-left: calc(50% - 3.3rem);
    top:50%;
    margin-top: -4.2rem;
    overflow: hidden;
  }
  .submit_box .box .close{
    font-size: .5rem;
    width: .6rem;
    height: .7rem;
    position: absolute;
    right: 0;
    top: 0
  }
  .submit_box .box .input-box{
    padding: 0 .3rem;
    margin-top: 1rem;
  }
  .submit_box .box .input-box .line-box{
    background:#f2f2f2;
    border-radius: 3px;
    display: flex;
    padding: 0 .2rem;
    height: .7rem;
    line-height: .7rem;
    margin-bottom: .3rem;
  }
  .submit_box .box .input-box .line-box p{
    font-size: .2rem;
    width:2rem;
    letter-spacing: 1px;
  }
  .submit_box .box .btn{
    width: 80%;
    height: .7rem;
    font-size: .3rem;
    background: #2982b9;
    color: #fff;
    margin: .5rem auto;
    border-radius: .35rem;
    text-align: center;
    line-height: .7rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/home.vue